import { Link } from "react-router-dom";

export default function TrustSection() {
  const trustItems = [
    {
      icon: "ri-bar-chart-box-line",
      title: "Price Transparency",
      description: "Full pricing visibility across all suppliers with no hidden costs or markup surprises.",
      link: "/acbuyspreadsheet-pricing",
      imgSrc: "https://readdy.ai/api/search-image?query=Glass%20jar%20filled%20with%20coins%20and%20a%20spreadsheet%20on%20a%20wooden%20table%20near%20sunlit%20window%2C%20soft%20morning%20light%2C%20warm%20amber%20and%20oatmeal%20tones%2C%20cozy%20home%20office%20vibe%2C%20lifestyle%20productivity%20photography%2C%20shallow%20depth%20of%20field%2C%20natural%20textures&width=600&height=400&seq=trust-v2-transparency&orientation=landscape",
    },
    {
      icon: "ri-refresh-line",
      title: "Daily Updates",
      description: "Our acbuyspreadsheet database refreshes every 24 hours so you never work with outdated listings.",
      link: "/acbuyspreadsheet-2026",
      imgSrc: "https://readdy.ai/api/search-image?query=Sunrise%20over%20a%20clean%20modern%20bedroom%20desk%20with%20an%20alarm%20clock%20and%20tablet%20showing%20calendar%20notification%2C%20soft%20orange%20morning%20glow%2C%20white%20linen%20and%20wooden%20furniture%2C%20fresh%20start%20concept%2C%20bright%20airy%20atmosphere%2C%20editorial%20lifestyle%20shot&width=600&height=400&seq=trust-v2-updates&orientation=landscape",
    },
    {
      icon: "ri-shield-check-line",
      title: "Verified Sources",
      description: "Every product listing is cross-checked against multiple supplier databases for accuracy.",
      link: "/acbuyspreadsheet-safety",
      imgSrc: "https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20a%20document%20with%20green%20checkmarks%20on%20a%20bright%20white%20desk%2C%20sunlight%20streaming%20through%20blinds%20creating%20striped%20shadows%2C%20clean%20professional%20setting%2C%20verification%20and%20trust%20concept%2C%20minimalist%20office%20photography%2C%20high%20key%20lighting&width=600&height=400&seq=trust-v2-verified&orientation=landscape",
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-start gap-6 mb-12 md:mb-16">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight lg:w-1/2">
            Why ACBuy Spreadsheet
            <span className="block text-foreground-600 font-light italic text-2xl md:text-3xl lg:text-4xl mt-1">
              changes the game
            </span>
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed lg:w-1/2 lg:pt-2">
            Built from the ground up for shoppers who demand transparency and speed,
            the <strong>acbuyspreadsheet</strong> system eliminates guesswork from your
            purchasing decisions with real-time data and verified comparisons.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {trustItems.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-100/70 rounded-xl overflow-hidden hover:bg-background-100 transition-colors duration-300"
            >
              <div className="w-full h-44 overflow-hidden bg-background-200/50">
                <img
                  src={item.imgSrc}
                  alt={`${item.title} — ACBuy Spreadsheet`}
                  title={`${item.title} — ACBuy Spreadsheet`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-6 md:p-7">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4">
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <h3 className="font-heading text-xl font-semibold text-foreground-950 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {item.description}
                </p>
                <Link
                  to={item.link}
                  className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors duration-200 whitespace-nowrap"
                >
                  Learn more
                  <i className="ri-arrow-right-line text-xs"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}